import React from "react";
import { Paper, Box, Rating } from "@mui/material";
import CustomText from "../CustomText";
import { useMediaQuery,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
const TestimonialCard = ({ quote, name, role, avatar, rating = 5, sx }) => {
     const theme = useTheme();
      const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  return (
    <Paper
      elevation={0}
      sx={{
         
          // border:{xs:"1px solid red",sm:"1px solid green",md:"1px solid orange"},
        // px:isMobile?2: 5,
            // width: "100%",
    px: isMobile ? 2 : 5,
        py:5,
        backgroundColor: "white",
        //  border:"1px solid rgb(240, 238, 238)",
        display: "flex",
        flexDirection: "column",
        gap: 2,
        position: "relative",
        zIndex: 1,
        // boxShadow: "0px 4px 25px 0px rgba(141, 141, 141, 0.05)",
        transition: 'transform 0.3s ease,box-shadow 0.3s ease, z-index 0.3s ',
        '&:hover': {
          transform: 'translateY(-12px) scale(1.03)',
          // boxShadow: '0px 2px 2px rgba(223, 228, 233, 0.2)',
          zIndex: 10,
          cursor:"pointer"
        },
        ...sx,
      }}
    >
      <CustomText
       style={{
          fontSize: "18px",
          fontWeight: 400,
          fontFamily: "Nunito, sans-serif",
          color: "#4A556C",
          textAlign: "left",
          lineHeight: "150%",
          wordBreak: "break-word", 
          overflowWrap: "break-word", 
          whiteSpace: "normal", 
        }}
      >
        "{quote}"
      </CustomText>

      <Box sx={{ display: "flex",flexDirection:"column" ,alignItems: "left", gap: 0 }}>
       
        <Box>
          <CustomText
            style={{
              fontSize: "24px",
              fontWeight: 700,
              fontFamily: "Poppins, sans-serif",
              color: "#333461",
              textAlign: "left",
              marginBottom: "0px",
            }}
          >
            {name}
          </CustomText>
          <CustomText
            style={{
              fontSize: "16px",
              fontWeight: 500,
              fontFamily: "Poppins, sans-serif",
              color: "#575771",
              textAlign: "left",
            }}
          >
            {role}
          </CustomText>
          {avatar && (
          <Box
            component="img"
            src={avatar}
            alt={name}
            sx={{
              marginTop:1,
              width:60,
              height:60,
              borderRadius: "50%",
              objectFit: "contain",
            }}
          />
        )}
        </Box>
      </Box>

      <Rating value={rating} readOnly />
    </Paper>
  );
};

export default TestimonialCard;
// import React from "react";
// import { Paper, Box, Rating } from "@mui/material";
// import CustomText from "../CustomText";
// import { useMediaQuery,} from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// const TestimonialCard = ({ quote, name, role, avatar, rating = 5, sx }) => {
//      const theme = useTheme();
//       const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
//   return (
//     <Paper
//       elevation={0}
//       sx={{
         
//           // border:{xs:"1px solid red",sm:"1px solid green",md:"1px solid orange"},
//         // px:isMobile?2: 5,
//             // width: "100%",
//     px: isMobile ? 2 : 5,
//         py:5,
//         backgroundColor: "white",
//         //  border:"1px solid rgb(240, 238, 238)",
//         display: "flex",
//         flexDirection: "column",
//         gap: 2,
//         position: "relative",
//         zIndex: 1,
//         // boxShadow: "0px 4px 25px 0px rgba(141, 141, 141, 0.05)",
//         transition: 'transform 0.3s ease,box-shadow 0.3s ease, z-index 0.3s ',
//         '&:hover': {
//           transform: 'translateY(-12px) scale(1.03)',
//           // boxShadow: '0px 2px 2px rgba(223, 228, 233, 0.2)',
//           zIndex: 10,
//           cursor:"pointer"
//         },
//         ...sx,
//       }}
//     >
//       <CustomText
//        style={{
//           fontSize: "18px",
//           fontWeight: 400,
//           fontFamily: "Nunito, sans-serif",
//           color: "#4A556C",
//           textAlign: "left",
//           lineHeight: "150%",
//           wordBreak: "break-word", 
//           overflowWrap: "break-word", 
//           whiteSpace: "normal", 
//         }}
//       >
//         "{quote}"
//       </CustomText>

//       <Box sx={{ display: "flex",flexDirection:"column" ,alignItems: "left", gap: 0 }}>
       
//         <Box>
//           <CustomText
//             style={{
//               fontSize: "24px",
//               fontWeight: 700,
//               fontFamily: "Poppins, sans-serif",
//               color: "#333461",
//               textAlign: "left",
//               marginBottom: "0px",
//             }}
//           >
//             {name}
//           </CustomText>
//           <CustomText
//             style={{
//               fontSize: "16px",
//               fontWeight: 500,
//               fontFamily: "Poppins, sans-serif",
//               color: "#575771",
//               textAlign: "left",
//             }}
//           >
//             {role}
//           </CustomText>
//           {avatar && (
//           <Box
//             component="img"
//             src={avatar}
//             alt={name}
//             sx={{
//               marginTop:1,
//               width:60,
//               height:60,
//               borderRadius: "50%",
//               objectFit: "contain",
//             }}
//           />
//         )}
//         </Box>
//       </Box>

//       <Rating value={rating} readOnly />
//     </Paper>
//   );
// };

// export default TestimonialCard;
